import { put, takeEvery, call, all } from "redux-saga/effects";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import * as actionTypes1 from "../TripDesignContainer/constants";

import { push } from "connected-react-router";
function* commonFunction(value) {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res.json();
    } else {
      const resJSON = yield res.json();

      if (value.alter) {
        resJSON.rows.forEach((element) => {
          element.driver = "";
          element.vehicle = "";
          element.name = "";
          element.email = "";
          element.driverId = "";
          element.vehicleId = "";
          element.mainLoad = true;
          element.tripRefNo = element.loadRefNo + "-T" + 1;
        });
        yield put({
          type: `${value.sucessAction}`,
          payload: resJSON,
        });
        //  yield put(push(value.navPage));
        return;
      }

      if (value.isArray) {
        yield put({
          type: `${value.sucessAction}`,
          payload: [resJSON],
        });
        return resJSON;
      } else {
        yield put({
          type: `${value.sucessAction}`,
          payload: resJSON,
        });
        return resJSON;
      }
    }
  } catch (err) {
    console.error("error", err);

    if (err.ok === false) {
      yield put({ type: `${value.failAction}`, error: err });
    } else {
    }
  }
}

function* fetchLoadData(value) {
  try {
    let page = (value.payload && value.payload.page) || 1;
    let params = {
      api: value.params.id
        ? `${appConfig.ip}/loadData?loadRefNo=${value.params.id && value.params.id.loadRefNo
        }&&status=created&limit=10&page=${page}`
        : `${appConfig.ip}/loadData?status=created&limit=10&page=${page}`,
      method: "GET",
      sucessAction: actionTypes.FETCH_TRIP_CRUD_LOAD_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_TRIP_CRUD_LOAD_FAIL_ACTION,
      body: null,
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* fetchDriverData(value) {
  let user = JSON.parse(localStorage.getItem("user"));
  let page = (value.params && value.params.page) || 1;
  try {
    let params = {
      api: `${appConfig.ip}/dProf/users?limit=5&page=${page}&status=active,created&orgId=${user.orgId}`,

      method: "GET",
      sucessAction: actionTypes.FETCH_LOAD_DRIVER_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_LOAD_DRIVER_FAIL_ACTION,
      body: null,
    };

    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* fetchVehicleData(value) {
  let user = JSON.parse(localStorage.getItem("user"));
  let page = (value.params && value.params.page) || 1;
  let driverId = (value.params && value.params.driver) || null;

  let api =
    value.params && value.params.driver
      ? `${appConfig.ip}/vehicleInvntry?status=active&limit=5&page=${page}&driverId=${driverId}&orgId=${user.orgId}`
      : `${appConfig.ip}/vehicleInvntry?status=active&limit=5&page=${page}&orgId=${user.orgId}`;

  try {
    let params = {
      api: `${api}`,
      method: "GET",
      sucessAction: actionTypes.FETCH_LOAD_VEHICLE_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_LOAD_VEHICLE_FAIL_ACTION,
      body: null,
    };

    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* updateTripPlanData(value) {
  try {
    let params = {
      api: `${appConfig.ip}/tripPlan`,
      method: "POST",
      sucessAction: actionTypes.UPDATE_TRIP_PLAN_CRUD_LOAD_SUCCESS_ACTION,
      failAction: actionTypes.UPDATE_TRIP_CRUD_LOAD_FAIL_ACTION,
      body: JSON.stringify(value.params.tripPlan),
    };
    const tripPlan = yield call(commonFunction, params);

    let trips = yield call(createTripData, value, tripPlan);

    yield put({
      type: actionTypes.UPDATE_TRIP_PLAN_PROCESSING_INIT_ACTION,
      payload: trips,
    });

    yield toast.success("Trip designed successfully", {
      autoClose: 3000,
      className: "toastClass"
    });
    yield put({
      type: actionTypes.CLEAR_SELECTED_LIST,
    })
    yield put(push("/tripDesign"));
  } catch (e) {
    console.error(e);
  }
}

function* createTripData(value, tripPlan) {
  try {
    let user = JSON.parse(localStorage.getItem("user"));
    yield all(
      tripPlan.load.map((el) => {
        let load = value.params.tripArray.map((ele) =>
          el.loadId === ele.id ? ele : ""
        );

        let data = {
          loadId: el.loadId,
          loadRefNo: el.loadRefNo,
          userId: user.id,
          userOrgId: user.orgId,
          custmrOrgId: el.custmrOrgId,
          custmrId: el.custmrId,
          fromDt: el.pickupDate,
          toDt: el.dropDate,
          driver: el.driver,
          vehicle: el.vehicle,
          tripPlanId: tripPlan.id,
          tripPlanRefNo: tripPlan.tripPlanRefNo,
          fromLoc: el.pAddr,
          toLoc: el.dAddr,
          dropTime: el.dropTime,
          pickTime: el.pickupTime,
          vehiclePlanId: el._id,
          tripRefNo: el.tripRefNo,
        };

        let params = {
          api: `${appConfig.ip}/trip`,
          method: "POST",
          sucessAction: actionTypes.UPDATE_TRIP_PLAN_CRUD_LOAD_SUCCESS_ACTION,
          failAction: actionTypes.UPDATE_TRIP_CRUD_LOAD_FAIL_ACTION,
          body: JSON.stringify(data),
        };

        return call(commonFunction, params);
      })
    );

    let payload = { payload: { page: 1 }, params: { id: null } };

    yield call(fetchLoadData, payload);
    yield put({
      type: actionTypes1.FETCH_LOAD_INIT_ACTION,
      value: { params: { page: 1, selectedTab: "created" } },
    });
  } catch (e) {
    console.error(e);
  }
}

function* updatePlannedTripPlanData(value) {
  try {
    let id = value.params.selectedList[0].id;
    let params = {
      api: `${appConfig.ip}/tripPlan/${id}`,
      method: "PUT",
      sucessAction: actionTypes.UPDATE_TRIP_PLAN_CRUD_LOAD_SUCCESS_ACTION,
      failAction: actionTypes.UPDATE_TRIP_CRUD_LOAD_FAIL_ACTION,
      body: JSON.stringify(value.params.tripPlan),
    };
    const tripPlan = yield call(commonFunction, params);
    yield call(updatePlannedTripData, value, tripPlan);
  } catch (e) {
    console.error(e);
  }
}

function* updatePlannedTripData(value, tripPlan) {
  try {
    let user = JSON.parse(localStorage.getItem("user"));

    if (value.params.trip && value.params.trip.newTrip) {
      let el = value.params.trip;
      let data = {
        loadId: el.loadId,
        loadRefNo: el.loadRefNo,
        userId: user.id,
        userOrgId: user.orgId,
        custmrOrgId: el.custmrOrgId,
        custmrId: el.custmrId,
        fromDt: el.pickupDate,
        toDt: el.dropDate,
        driver: el.driver,
        vehicle: el.vehicle,
        tripPlanId: value.params.selectedList[0].id,
        tripPlanRefNo: value.params.selectedList[0].tripPlanRefNo,
        fromLoc: el.pAddr,
        toLoc: el.dAddr,
        dropTime: el.dropTime,
        pickTime: el.pickupTime,
        vehiclePlanId: el._id,
        tripRefNo: el.tripRefNo,
      };

      let params = {
        api: `${appConfig.ip}/trip`,
        method: "POST",
        sucessAction: actionTypes.UPDATE_TRIP_PLAN_CRUD_LOAD_SUCCESS_ACTION,
        failAction: actionTypes.UPDATE_TRIP_CRUD_LOAD_FAIL_ACTION,
        body: JSON.stringify(data),
      };

      yield call(commonFunction, params);

      yield toast.success("Trip updated successfully", {
        autoClose: 3000,
        className: "toastClass"
      });
      yield put({
        type: actionTypes.CLEAR_SELECTED_LIST,
      })
      yield put(push("/tripDesign"));
    } else {
      let el = value.params.trip;
      let data = {
        fromDt: el.pickupDate,
        toDt: el.dropDate,
        driver: el.driver,
        vehicle: el.vehicle,
        dropTime: el.dropTime,
        pickTime: el.pickupTime,
      };

      let params = {
        api: `${appConfig.ip}/trip/upsert/${el.tripRefNo}`,
        method: "PUT",
        sucessAction: actionTypes.UPDATE_TRIP_PLAN_CRUD_LOAD_SUCCESS_ACTION,
        failAction: actionTypes.UPDATE_TRIP_CRUD_LOAD_FAIL_ACTION,
        body: JSON.stringify(data),
      };
      const tripPlan = yield call(commonFunction, params);
      yield toast.success("Trip updated successfully", {
        autoClose: 3000,
        className: "toastClass"
      });
      yield put({
        type: actionTypes.CLEAR_SELECTED_LIST,
      })
      yield put(push("/tripDesign"));
    }
  } catch (e) {
    console.error(e);
  }
}

function* fetchTripPlanById(value) {
  let user = JSON.parse(localStorage.getItem("user"));

  try {
    let page = (value.params && value.params.page) || 1;

    let params = {
      page: page,
      api: `${appConfig.ip}/tripPlan/${value.payload}`,
      method: "GET",
      sucessAction: actionTypes.FETCH_TRIP_PLAN_BY_ID_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_TRIP_PLAN_BY_ID_FAIL_ACTION,
      body: null,
      isArray: true,
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* fetchLoadByIds(value) {
  let user = JSON.parse(localStorage.getItem("user"));

  try {
    let page = (value.params && value.params.page) || 1;
    let params = {
      page: page,
      api: `${appConfig.ip}/loadData/load?_id=${value.payload.id}`,
      // api: `${appConfig.ip}/loadData/load?_id=620dc9508a8588de9ac99d1d`,

      method: "GET",
      sucessAction: actionTypes.FETCH_LOAD_BY_IDS_INIT_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_LOAD_BY_IDS_FAIL_ACTION,
      body: null,
      alter: true,
      // navPage:
      //   value.payload.status === "created"
      //     ? "/tripDesignPage"
      //     : "/pendingDesign",
    };

    yield call(commonFunction, params);
    console.log("=====value.payload.tabKey=======", value.payload.tabKey)
    if (value.payload.tabKey !== "created") {
      yield call(fetchBidData, value);
    }
  } catch (e) {
    console.error(e);
  }
}

function* deletePlannedTripPlanData(value) {
  try {
    let id = value.payload.tripPlan.id;

    let tripaplan = value.payload.tripPlan;

    tripaplan &&
      tripaplan.load.map((ele) => {
        ele.vehicle = ele.vehicle.id;
        ele.driver = ele.driver._id;
        ele.loadId = ele.loadId.id;
      });

    let params = {
      api: `${appConfig.ip}/tripPlan/${id}`,
      method: "PUT",
      sucessAction: actionTypes.DELETE_PLANNED_SELECTED_TRIP_SUCCESS_ACTION,
      failAction: actionTypes.DELETE_PLANNED_SELECTED_TRIP_FAIL_ACTION,
      body: JSON.stringify({
        ...tripaplan,
        userId: tripaplan.userId.id,
      }),
    };
    const tripPlan = yield call(commonFunction, params);

    let el = value.payload.selectedItem;
    let data = {
      ...el,
      status: "deleted",
      tripRefNo: el.tripRefNo + "_deleted_" + new Date().getTime(),
      driver: el.driver._id,
      vehicle: el.vehicle.id,
    };
    let tripParams = {
      api: `${appConfig.ip}/trip/status/${el.tripRefNo}`,
      method: "PUT",
      sucessAction: actionTypes.UPDATE_TRIP_PLAN_CRUD_LOAD_SUCCESS_ACTION,
      failAction: actionTypes.UPDATE_TRIP_CRUD_LOAD_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const trip = yield call(commonFunction, tripParams);
    yield call(fetchTripPlanById, { payload: value.payload.tripPlan.id });
    yield toast.success("Trip updated successfully", {
      autoClose: 3000,
      className: "toastClass"
    });
  } catch (e) {
    console.error(e);
  }
}

function* fetchSubCatData(value) {
  try {
    let user = JSON.parse(localStorage.getItem("user"));
    let page = (value.payload && value.payload.page) || 1;
    let params = {
      //api: `${appConfig.ip}/subCategory?isActive=true&limit=10&page=${page}`,//This was used initially.Changed on June 24th
      // api: `${appConfig.ip}/subCategory?&page=${page}&limit=10&isActive=true`,
      api: `${appConfig.ip}/rateCard/subCategory?orgId=${user.orgId}&page=${page}&limit=10&isActive=true`,
      method: "GET",
      sucessAction: actionTypes.FETCH_VEHICLE_SUB_CAT_INIT_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_VEHICLE_SUB_CAT_FAIL_ACTION,
      body: null,
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* createBidAction(value) {
  try {
    let user = JSON.parse(localStorage.getItem("user"));
    let loadData = value.payload.load;
    let formData = value.payload.value;
    let postData = {
      loadId: loadData.id,
      loadRefNo: loadData.loadRefNo,
      bidType: "",
      custmrId: loadData.userId.id,
      custmrOrgId: loadData.userId.orgId,
      bidUserId: user.id,
      orgId: user.orgId,
      orgType: user.role,
      orgName: user.orgName,
      rate: formData.amount,
      status: "created",
      disc: value.payload.formValue.bidNote,
      estimateId: "",
      crncyCode: (user.curncyCode && user.curncyCode) || null,
      reQuote: "",
      vehicleType: formData,
      // noOfVehicles: formData.count,
    };
    let page = (value.payload && value.payload.page) || 1;
    let params = {
      api: `${appConfig.ip}/bid`,
      method: "POST",
      sucessAction: actionTypes.CREATE_BID_INIT_ACTION_SUCCESS_ACTION,
      failAction: actionTypes.CREATE_BID_INIT_ACTION_FAIL_ACTION,
      body: JSON.stringify(postData),
    };
    yield call(commonFunction, params);
    yield toast.success("Bid quoted successfully", {
      autoClose: 3000,
      className: "toastClass"
    });
    yield call(updateLoadData, value);
    yield put({
      type: actionTypes.CLEAR_SELECTED_LIST
    })
    yield put(push("/tripDesign"));
  } catch (e) {
    console.error(e);
  }
}

function* updateLoadData(value) {
  try {
    let loadData = value.payload.load;

    let params = {
      api: `${appConfig.ip}/loadData/${loadData.id}`,
      method: "PUT",
      sucessAction: actionTypes.DELETE_PLANNED_SELECTED_TRIP_SUCCESS_ACTION,
      failAction: actionTypes.DELETE_PLANNED_SELECTED_TRIP_FAIL_ACTION,
      body: JSON.stringify({
        status: "bid",
      }),
    };
    const tripPlan = yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* fetchBidData(value) {
  try {
    let page = (value.payload && value.payload.page) || 1;
    let params = {
      api: `${appConfig.ip}/bid?loadId=${value.payload.id}`,

      method: "GET",
      sucessAction:
        actionTypes.FETCH_BID_BY_INIT_ACTION_TRIP_DESIGN_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_TRIP_CRUD_LOAD_FAIL_ACTION,
      body: null,
    };
    let bid = yield call(commonFunction, params);
    if (bid.rows && bid.rows[0].status === 'accepted') {
      yield put(push('/tripDesign/tripDesignPage', { id: [value.payload.id] }))
    }
  } catch (e) {
    console.error(e);
  }
}

function* fetchPaymnt(action) {
  try {
    let params = {
      api: `${appConfig.ip}/payment?loadId=${action.payload}`,

      method: "GET",
      sucessAction: actionTypes.FETCH_PAYMNT_INIT_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_PAYMNT_INIT_FAIL_ACTION,
      body: null,
    };

    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

export function* tripDesignCRUDActionWatcher() {
  yield takeEvery(actionTypes.FETCH_TRIP_CRUD_LOAD_INIT_ACTION, fetchLoadData);
  yield takeEvery(actionTypes.FETCH_LOAD_DRIVER_INIT_ACTION, fetchDriverData);
  yield takeEvery(actionTypes.FETCH_LOAD_VEHICLE_INIT_ACTION, fetchVehicleData);
  yield takeEvery(
    actionTypes.UPDATE_TRIP_PLAN_CRUD_LOAD_INIT_ACTION,
    updateTripPlanData
  );
  yield takeEvery(
    actionTypes.UPDATE_PLANNED_TRIP_PLAN_CRUD_LOAD_INIT_ACTION,
    updatePlannedTripPlanData
  );
  yield takeEvery(
    actionTypes.FETCH_TRIP_PLAN_BY_ID_INIT_ACTION,
    fetchTripPlanById
  );
  yield takeEvery(actionTypes.FETCH_LOAD_BY_IDS_INIT_ACTION, fetchLoadByIds);
  yield takeEvery(
    actionTypes.DELETE_PLANNED_SELECTED_TRIP_INIT_ACTION,
    deletePlannedTripPlanData
  );
  yield takeEvery(
    actionTypes.FETCH_VEHICLE_SUB_CAT_INIT_ACTION,
    fetchSubCatData
  );
  yield takeEvery(actionTypes.CREATE_BID_INIT_ACTION, createBidAction);
  yield takeEvery(actionTypes.FETCH_PAYMNT_INIT_ACTION, fetchPaymnt);
}
